import type { Problem } from 'store/types/common';
import { SheetType } from './client-blank-estimate-list';
import { Label } from '@gravity-ui/uikit';
import { format } from 'date-fns';
import styles from './styles.module.scss';

interface ProblemSheetContentProps {
	problem: Problem;
	sheetType: SheetType;
}

export const ProblemSheetContent = ({ problem, sheetType }: ProblemSheetContentProps) => {
	let title = '';
	let content: JSX.Element | null = null;

	// Группируем estimate по датам и выбираем последний по ID для каждой даты
	const getUniqueEstimatesByDate = () => {
		if (!problem?.estimate) return [];

		const estimatesByDate = problem.estimate.reduce(
			(acc, est) => {
				const dateKey = est.date || '';
				if (!acc[dateKey]) {
					acc[dateKey] = [];
				}
				acc[dateKey].push(est);
				return acc;
			},
			{} as Record<string, typeof problem.estimate>,
		);

		// Для каждой даты выбираем estimate с максимальным ID
		const uniqueEstimates = Object.values(estimatesByDate).map((estimates) =>
			estimates.reduce((latest, current) => {
				return (current.id || 0) > (latest.id || 0) ? current : latest;
			}),
		);

		// Сортируем по дате
		return uniqueEstimates.sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime());
	};

	const uniqueEstimates = getUniqueEstimatesByDate();

	if (sheetType === 'execution') {
		title = 'Выполнение';
		content = (
			<ul>
				{uniqueEstimates.map((est) => (
					<li key={est.id}>
						{est.date ? format(new Date(est.date), 'dd.MM.yyyy') : ''}
						<Label theme="normal">{est.execution}</Label>
					</li>
				))}
			</ul>
		);
	} else if (sheetType === 'satisfaction') {
		title = 'Удовлетворенность';
		content = (
			<ul>
				{uniqueEstimates.map((est) => (
					<li key={est.id}>
						{est.date ? format(new Date(est.date), 'dd.MM.yyyy') : ''}
						<Label theme="normal">{est.satisfaction}</Label>
					</li>
				))}
			</ul>
		);
	}

	return (
		<div className={styles.sheet_container}>
			<h3>{title}</h3>
			{content}
		</div>
	);
};
